import pluralize from 'pluralize';

type MaterialProps = {
  unitOfMeasurementId?: number | null;
  unitsOfMeasurement:
    | ({
        id: number;
        name: string;
        isDefault: boolean;
      } | null)[]
    | null;
} | null;

export function getMaterialUnitOfMeasurement(material: MaterialProps) {
  if (!material?.unitOfMeasurementId) {
    return material?.unitsOfMeasurement?.find(uom => uom?.isDefault) || null;
  }
  return (
    material.unitsOfMeasurement?.find(
      uom => uom?.id === material.unitOfMeasurementId
    ) || null
  );
}

export const getDefaultUnitOfMeasurement = (materials: MaterialProps) => {
  return materials?.unitsOfMeasurement?.find(uom => uom?.isDefault) || null;
};

export function getMaterialUnitOfMeasurementOptions(
  material: MaterialProps,
  numberOfItems: number
) {
  if (!material?.unitsOfMeasurement?.length) {
    return [];
  }

  return (
    material.unitsOfMeasurement.map(uom => {
      const unitOfMeasurementName = uom?.name || '';
      return {
        value: `${uom?.id}`,
        label: getPluralizedUnitOfMeasurement(
          unitOfMeasurementName,
          Number(numberOfItems)
        ),
      };
    }) || []
  );
}

export function getMaterialUnitOfMeasurementData({
  material,
  numberOfItems,
  selectedUnitOfMeasurementId,
}: {
  material: MaterialProps;
  numberOfItems: number;
  selectedUnitOfMeasurementId: number | null | undefined;
}) {
  const materialUnitOfMeasurementOptions = getMaterialUnitOfMeasurementOptions(
    material,
    numberOfItems
  );

  return {
    materialUnitOfMeasurementOptions,
    hasUnitOfMeasurementOptions: !!materialUnitOfMeasurementOptions.length,
    selectedUnitOfMeasurementLabel: materialUnitOfMeasurementOptions.find(
      uom =>
        uom.value ===
        `${selectedUnitOfMeasurementId ||
          getMaterialUnitOfMeasurement(material)?.id}`
    )?.label,
  };
}

export function getPluralizedUnitOfMeasurement(
  unitOfMeasurementName: string,
  numberOfItems: number
) {
  return unitOfMeasurementName === 'stone'
    ? 'stone'
    : pluralize(unitOfMeasurementName, numberOfItems);
}
